import { fetchPrices, COINGECKO_IDS } from '../../services/priceService';

export default {
  namespaced: true,
  state: () => ({
    prices: {},
    changes: {},
    lastFetch: 0,
  }),
  mutations: {
    SET_PRICES(state, { prices, changes }) {
      state.prices = prices;
      state.changes = changes || {};
      state.lastFetch = Date.now();
    },
  },
  actions: {
    async fetchPrices({ commit, state }, tickers) {
      if (Date.now() - state.lastFetch < 60000) return;
      const { prices, changes } = await fetchPrices(tickers || Object.keys(COINGECKO_IDS));
      commit('SET_PRICES', { prices, changes });
    },
  },
  getters: {
    usdValue: (state) => (ticker, rawBalance) => {
      const raw = parseFloat(String(rawBalance).replace(/,/g, '')) || 0;
      return raw * (state.prices[ticker] ?? 0);
    },
    change24h: (state) => (ticker) => state.changes[ticker] ?? null,
  },
};
